export enum MovieTypeEnum {
	NOW_IN_THEATERS = 'now_in_theaters',
	COMING_SOON_TO_THEATERS = 'coming_soon_to_theaters',
	OUR_PREVIOUS_FILMS = 'our_previous_films',
}
